module.exports = __webpack_public_path__ + "static/media/h2.6e84b1e8.jpg";